import * as React from 'react';
import type { CollectionEditFormSchema } from './collection-edit-dialog';

interface UseCollectionEditDialogProps {
  /** Collection ID */
  collectionId: string;
  /** Portfolio ID */
  workspaceId?: string;
  /** Organization ID */
  organizationId?: string;
  /** Function to call when the collection is successfully renamed */
  onSuccessfulRename: (newName: string) => void | Promise<void>;
}

/**
 * Hook for managing collection editing
 * Handles form submission and error states
 *
 * @param props - Hook configuration
 * @returns Object containing submission state and handlers
 */
function useCollectionEditDialog(props: UseCollectionEditDialogProps) {
  const { onSuccessfulRename } = props;
  const [submissionErrorMessage] = React.useState<string | null>(null);

  const handleOnSubmit = async (data: CollectionEditFormSchema) => {
    // Call the success callback and wait for it to complete
    // Actual API mutation is handled by the parent component via useCollectionMenuActions hook
    await onSuccessfulRename(data.name);
  };

  return {
    submissionErrorMessage,
    onSubmit: handleOnSubmit,
  };
}

export { useCollectionEditDialog };
